import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import {
  debounceTime,
  delay,
  distinctUntilChanged,
  filter,
  switchMap,
  tap
} from 'rxjs/operators';
import { ConfigService } from 'src/app/services/config.service';
import { LayoutService, NavbarBtn } from 'src/app/layout/layout.service';
import { AdminService } from 'src/app/admin-pages/admin.service';
import { VariantService } from 'src/app/admin-pages/variant.service';
@Component({
  selector: 'app-product-list',
  templateUrl: './service-product-list.component.html',
  styleUrls: ['./service-product-list.component.scss'],
})
export class ServiceProductListComponent implements OnInit, OnDestroy {
  searchForm: FormGroup;
  isSearchActive: boolean = false;
  is_openSearch: boolean = false;
  searchKeyword: string = '';
  isReseller!: boolean;
  isExpandFilter: boolean = false;

  productType: string = '';

  list_array: any[] = [];
  Category_array: any = [];
  selectedCat = 0;
  previousState: any = {};

  // notification variables
  notificationMsg: string = '';
  showNotification: boolean = false;
  notificationTypeError: boolean = false;

  // lazy load vriables
  sum = 50;
  throttle = 300;
  scrollDistance = 3;
  scrollUpDistance = 1.5;
  isEndOfList = false;
  isLazyloading: boolean = false;
  skip = 0;
  take = 50;

  toolbarData: any = {};
  loading: boolean = true;
  summaryLoading: boolean = true;
  isShowDeletePopup: boolean = false;
  deleteProductItem: any;
  subscription = new Subscription();
  copyButtonLabel: string = 'Copy';
  showInactiveProductsOnly: boolean = false;
  showUnpublishedProductsOnly: boolean = false;
  showOutOfStockProductsOnly: boolean = false;

  OnErrorImage: string =
    'https://bazaarnear.com/uploads///bazaarnear_38095985.jpg';

  productStatusOptions = [
    { label: 'Inactive Products', value: 'inactive' },
    { label: 'Unpublished Products', value: 'unpublished' },
    { label: 'Out of Stock Products', value: 'outOfStock' },
  ];

  productslistFilterForm: FormGroup;
  constructor(
    public configService: ConfigService,
    public adminService: AdminService,
    private router: Router,
    private fb: FormBuilder,
    public vs: VariantService,
    private layoutService: LayoutService,
  ) { }

  ngOnInit(): void {
    this.isReseller = this.configService?.isReseller;
    this.list_array = [];
    this.populateToolbarData();
    this.getproducts(this.skip, this.take, 0);
    this.searchForm = this.fb.group({
      search: '',
    });

    this.productslistFilterForm = this.fb.group({
      productStatus: [undefined],
    });

    this.subscription.add(
      this.layoutService.routeReattached$.pipe(filter(k => k === 'servicenear/serviceProductList')).subscribe(() => this.refreshToolbar())
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.layoutService.setToolbar({});
  }

  private refreshToolbar() {
    this.layoutService.setToolbar({
      title: 'Service Product list',
    });
    this.layoutService.setNavbarButtons([
      // { action: 'add', state: null, icon: 'add' },
      { action: 'search', state: null, icon: 'search' },
      // { action: 'filter', state: null, icon: 'filter_list' },
    ]);
  }

  private populateToolbarData() {
    this.refreshToolbar();

    this.subscription.add(
      this.layoutService.buttonClicked$.subscribe((btn: NavbarBtn) => {
        if (!btn) return;

        switch (btn.action) {
          case 'add':
            this.router.navigate(['products/product-edit/0']);
            break;
          case 'filter':
            this.openFilterClick();
            break;
          case 'search':
            this.searchClicked();
            break;
        }
      }),
    );
  }

  public refresh() {
    location.reload();
  }

  public processCurrentVariant(productsArray: any) {
    productsArray.map((product: any) => {
      let raw = product?.CurrentVariantData;
      let varData: any[] = [];
      try {
        const parsed = JSON.parse(raw ?? '[]');
        varData = Array.isArray(parsed) ? parsed : [];
      } catch {
        varData = [];
      }

      if (varData.length) {
        let size = varData.find((item: any) => item.variantType === 'Size');
        product.productSize = size?.variantValue;
      }
    });
  }

  public onScroll(ev) {
    if (!this.loading && !this.isEndOfList) {
      this.skip += this.sum;
      this.take = this.sum;
      this.getproducts(this.skip, this.sum, this.selectedCat, true);
    }
  }

  public onUp(ev) { }

  private getproducts(
    skip: number,
    take: number,
    categoryID,
    isLazyLoad = false,
  ) {
    this.loading = true;
    if (isLazyLoad) {
      this.loading = false;
      this.isLazyloading = true;
    } else {
      this.loading = true;
      this.isLazyloading = false;
    }
    let params = {
      takeAll: false,
      skip: 0,
      take: 100,
      categoryID: 0,
      keyword: '',
      productsFor: 'admin',
      organisationID: 0,
      productsType: 'service',
      ShowInactiveProductsOnly: false,
      ShowUnpublishedProductsOnly: false,
      ShowOutOfStockProductsOnly: false,
    };
    this.subscription.add(
      this.adminService.getServiceProductList(params).subscribe(
        (res: any) => {
          this.isLazyloading = false;
          if (res.Result == 'Success' && res.ResponseData) {
            this.processCurrentVariant(res.ResponseData);
            this.list_array.push(...res.ResponseData);
            if (res.ResponseData.length < 50) {
              this.isEndOfList = true;
            } else {
              this.isEndOfList = false;
            }
          }
          this.loading = false;
        },
        (error: HttpErrorResponse) => {
          this.loading = false;
          this.isLazyloading = false;
          console.log('------------------------');
          console.log(error);
          console.log('------------------------');
        },
      ),
    );
  }

  public navigateToProductAdd() {
    if (this.isReseller) {
      this.router.navigate(['/Reseller/AddProduct']);
    } else {
      this.router.navigate(['products/product-edit/0']);
    }
  }

  searchClicked() {
    this.is_openSearch = !this.is_openSearch;
    this.searchKeyword = '';
    this.isEndOfList = false;
    this.resetSkipTake();

    if (!this.is_openSearch) {
      this.isSearchActive = false;
      this.searchKeyword = '';
      this.resetList();
      this.getproducts(this.skip, this.take, this.selectedCat);
    } else {
      this.searchForm.controls['search'].setValue('');
      this.subscription.add(
        this.searchForm.controls['search'].valueChanges
          .pipe(
            debounceTime(300),
            distinctUntilChanged(),
            tap(() => (this.isSearchActive = true)),
            delay(300),
            switchMap((str: string) => {
              this.searchKeyword = str;
              this.resetList();
              let params = {
                takeAll: false,
                skip: this.skip,
                take: this.take,
                categoryID: this.selectedCat,
                keyword: this.searchKeyword,
                productsFor: 'admin',
                productsType: 'service',
                organisationID: 0,
              };
              return this.adminService.getServiceProductList(params);
            }),
          )
          .subscribe((res: any) => {
            this.isSearchActive = false;
            this.processCurrentVariant(res.ResponseData);
            this.list_array = res.ResponseData;
            if (res.ResponseData.length < 50 && res.RowCount < 50) {
              this.isEndOfList = true;
            } else {
              this.isEndOfList = false;
            }
          }),
      );
    }
  }

  public goToEdit(item: any) {
    this.router.navigate(['products/product-edit/', item.ID]);
  }

  private resetList() {
    this.list_array = [];
    this.isEndOfList = false;
    this.resetSkipTake();
  }

  private resetSkipTake() {
    this.skip = 0;
    this.take = 50;
  }

  goToProductDetails(id) {
    this.router.navigate(['/products/product-details', id]);
  }

  showToastMsg(isError: boolean, msg: string) {
    this.showNotification = true;
    this.notificationTypeError = isError;
    this.notificationMsg = msg;
    setTimeout(() => {
      this.showNotification = false;
      this.notificationTypeError = false;
      this.notificationMsg = '';
    }, 1000);
  }

  openFilterClick() {
    this.showInactiveProductsOnly = false;
    this.isExpandFilter = !this.isExpandFilter;
  }

  public onProductStatusChange(event: any) {
    this.resetList();
    let selectedStatusValue = event.value;
    this.showInactiveProductsOnly = false;
    this.showUnpublishedProductsOnly = false;
    this.showOutOfStockProductsOnly = false;
    if (selectedStatusValue) {
      if (selectedStatusValue === 'inactive') {
        this.showInactiveProductsOnly = true;
      } else if (selectedStatusValue === 'unpublished') {
        this.showUnpublishedProductsOnly = true;
      } else if (selectedStatusValue === 'outOfStock') {
        this.showOutOfStockProductsOnly = true;
      }
    }
    this.getproducts(this.skip, this.take, 0);
  }

  public clearFilter() {
    this.showInactiveProductsOnly = false;
    this.showUnpublishedProductsOnly = false;
    this.showOutOfStockProductsOnly = false;
    this.resetList();
    this.productslistFilterForm.reset();
    this.getproducts(this.skip, this.take, 0);
    this.isExpandFilter = false;
  }

  AddAnotherProduct() {
    this.vs.productSuccessConfirmationBanner = false;
    this.router.navigate(['products/product-edit/0']);
  }

  viewProduct(id: any) {
    this.vs.productSuccessConfirmationBanner = false;
    this.router.navigate(['/products/product-details', id]);
  }

  CopyProductUrl() {
    const productUrl = this.vs?.productUrl;
    navigator.clipboard
      .writeText(productUrl)
      .then(() => {
        this.copyButtonLabel = 'Copied';
      })
      .catch((err) => {
        console.warn('Failed to copy text: ', err);
      });
  }

  onImageError(event: any) {
    event.target.src = this.OnErrorImage;
  }
}
